import PlateEntry from './PlateEntry';

export default PlateEntry;
